import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Header.css'; 

const Header = () => (
  <header>
    <nav>
      <div className="logo">HRZ Landscaping</div>
      <div className="logo2">(415) 235-2545</div>
      <ul className="nav-links">
        <li><Link to="/">Home</Link></li>
        <li className="dropdown">
          <a href="#services">Services</a>
          <ul className="dropdown-menu">
            <li><Link to="/maintenance">Maintenance</Link></li>
            <li><Link to="/stone">Stone Work</Link></li>
            <li><Link to="/fence">Deck and Fence</Link></li>
            <li><Link to="/planting">Planting and Irrigation</Link></li>
          </ul>
        </li>
        <li><Link to="/contact">Contact</Link></li>
        <li><Link to="/about">About</Link></li>
      </ul>
    </nav>
  </header>
);

export default Header;
